import reportService from "@/services/report";

export default {
  data: () => ({
    reportItem: [],
  }),
  methods: {
    async fetchTakenReport(params, companyId = null) {
      if (this.loading !== undefined) {
        this.loading = true;
      }

      const requestId = (this.takenRequestId = (this.takenRequestId || 0) + 1);
      try {
        // useSummary (opciono, definiše komponenta): gotovi zbirovi food-orders-summary, samo za
        // sve firme. summaryGroup "orders" vraća red po firmi i smeni (orders_count, meals...).
        const useSummary = this.useSummary && companyId === null;
        const response = useSummary
          ? await reportService.getFoodOrdersSummary(this.$store.state.restaurant.id, {
              ...params,
              ...(this.summaryGroup ? { group: this.summaryGroup } : {}),
            })
          : await reportService.getFoodOrdersOrdered(this.$store.state.restaurant.id, params);
        if (requestId !== this.takenRequestId) return;
        this.reportItem = response.data.filter((item) => {
          return item.company_id === companyId || companyId === null;
        });
      } catch (error) {
        if (requestId !== this.takenRequestId) return;
        console.error("Error fetching taken report:", error);
        this.reportItem = [];
      } finally {
        if (this.loading !== undefined && requestId === this.takenRequestId) {
          this.loading = false;
        }
      }
    },
  },
  computed: {
    filters() {
      return this.$store.state.report.filters;
    },
  },
};
